const addAccessTokenToUrl = (url: string, queryParams: Record<string, string>) => {
  try {
    const updatedUrl = new URL(url, window.location.origin);
    Object.entries(queryParams).forEach(([key, value]) => {
      updatedUrl.searchParams.set(key, value);
    });
    return updatedUrl.toString();
  } catch (error) {
    return new URL('/pages/error/error-404', window.location.origin).toString();
  }
};

export { addAccessTokenToUrl };
